var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center font-weight-regular px-5 py-0",staticStyle:{"color":"#888"}},[_c('font',{attrs:{"size":"1"}},[_vm._v("Powered by Ocular")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }